import React from 'react';

interface ButtonSelectProps<T extends string | number> {
  options: T[];
  selected: T | null | undefined;
  onChange: (value: T) => void;
  disabled?: boolean;
  title?: string;
  renderLabel?: (value: T) => string;
  buttonClassName?: string;
}

function ButtonSelect<T extends string | number>({
  options,
  selected,
  onChange,
  disabled = false,
  title,
  renderLabel,
  buttonClassName = '',
}: ButtonSelectProps<T>) {
  return (
    <>
      {title && <label className="settings-field-label">{title}</label>}
      <div className="d-flex flex-wrap gap-2 mt-1">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            className={`btn ${selected === option ? 'btn-primary' : 'btn-outline-secondary'} ${buttonClassName}`.trim()}
            onClick={() => onChange(option)}
            disabled={disabled}
          >
            {renderLabel ? renderLabel(option) : String(option)}
          </button>
        ))}
      </div>
    </>
  );
}

export default ButtonSelect;
